import {
  SourceType as ActionComposeSourceType,
  ActionType as ActionComposeActionType,
} from './actionCompose';
import getClient from './getClient';
// TODO: Check these (PLAYB-155 / WFA-110)

export type GetActionsResponse = {
  data: Action[];
};

// Double check with omnibar action type for overlap
// libs/api/src/lib/services/v1/actions.ts
export type Action = {
  id: number;
  summary: string;
  source: SourceType;
  who: Who;
  due_at: string;
  creator: Person;
  assignee: Person;
  body?: string;
  subject?: string;
  priority?: string;
  deleted_at?: string;
  completed_at?: string;
  failed?: boolean;
  type?: ActionType;
  smart_priority?: number;
};

export type SourceType = ActionComposeSourceType;
export type ActionType = ActionComposeActionType | AdditionalActionTypes;
type AdditionalActionTypes =
  // overlap:
  //   | 'CALL'
  //   | 'GENERAL'
  //   | 'OTHER'
  | 'EMAIL'
  | 'IN_MAIL'
  | 'LINKEDIN_CONNECT'
  | 'SENDOSO'
  | 'SMS'
  // Are these still a thing?
  | 'IN_PERSON_VISIT'
  | 'DIRECT_MAIL'
  | 'WORKSPACE'
  | 'SALESFORCE';

// TODO: Check these (PLAYB-155)
export type Who = {
  id: number;
  name: string;
  company?: string;
  title?: string;
  tzid?: string;
  engagement_score?: number;
  sfdc_id: string;
};

export type Person = {
  id: number;
  name: string;
};

export type SearchParams = {
  page?: number;
  per_page?: number;
};

export const getActions = (
  searchParams: SearchParams,
): Promise<GetActionsResponse> =>
  getClient().get('actions', { searchParams }).json();
